import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import MainLayout from './components/MainLayout.jsx';
import AuthCallback from './components/AuthCallback.jsx';
import RequirePermission from './components/auth/RequirePermission.jsx';

import { lazyModule } from './components/ui/lazyModule.jsx';

const LoginPage = lazyModule(() => import('./components/LoginPage.jsx'), 'Login');
const PlayableTestViewer = lazyModule(() => import('./components/PlayableTestViewer.jsx'), 'Playable Test Viewer');
const PlayableManager = lazyModule(() => import('./components/PlayableManager.jsx'), 'Playable Manager');
const UserManagement = lazyModule(() => import('./components/UserManagement.jsx'), 'User Management');
const OverviewPage = lazyModule(() => import('./pages/OverviewPage.jsx'), 'Overview');
const CreativeManagerPage = lazyModule(() => import('./pages/CreativeManagerPage.jsx'), 'Creative Manager');
const CampaignsPage = lazyModule(() => import('./pages/CampaignsPage.jsx'), 'Campaigns');
const SettingsPage = lazyModule(() => import('./pages/SettingsPage.jsx'), 'Settings');
const AutomationsPage = lazyModule(() => import('./pages/AutomationsPage.jsx'), 'Automations');
const UaoNetworksPage = lazyModule(() => import('./pages/UaoNetworksPage.jsx'), 'Uao Networks');

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/auth/google/callback" element={<AuthCallback />} />
          <Route
            path="/playable-test"
            element={
              <div className="app-container playable-test-container">
                <main className="playable-test-content">
                  <PlayableTestViewer />
                </main>
              </div>
            }
          />

          <Route element={<ProtectedRoute />}>
            <Route element={<MainLayout />}>
              <Route path="/overview" element={<OverviewPage />} />
              <Route
                path="/creative-manager"
                element={
                  <RequirePermission codename="creatives.view">
                    <CreativeManagerPage />
                  </RequirePermission>
                }
              />
              <Route
                path="/campaigns"
                element={
                  <RequirePermission codename="campaigns.view">
                    <CampaignsPage />
                  </RequirePermission>
                }
              />
              <Route
                path="/playable-manager"
                element={
                  <RequirePermission codename="playables.view">
                    <PlayableManager />
                  </RequirePermission>
                }
              />
              <Route
                path="/automations"
                element={
                  <RequirePermission codename="automations.view">
                    <AutomationsPage />
                  </RequirePermission>
                }
              />
              <Route
                path="/user-management"
                element={
                  <RequirePermission any={['users.view', 'roles.view']}>
                    <UserManagement />
                  </RequirePermission>
                }
              />
              <Route
                path="/uao/networks"
                element={
                  <RequirePermission codename="uao.view">
                    <UaoNetworksPage />
                  </RequirePermission>
                }
              />
              <Route path="/settings" element={<SettingsPage />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/creative-manager" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
